import CrudRepository from './CrudRepository'
export default class SocialResponsibilityCardDetails extends CrudRepository {
  constructor () {
    super('customerCare/api/socialResponsibility')
  }
}
